import { useTextes } from '@common/config';
import { z } from 'zod';
import { Z_EFFECTIF_APPRENTI, Z_NDA, Z_PERCENTAGE, Z_SIREN, Z_TEXT } from '../../..';
import { Z_CODE_POSTAL } from '../../../etablissement';

const t = useTextes('Commun', 'Formulaire');

export const editOfaInfoFormSchema = z.object({
  raisonSociale: Z_TEXT(),
  siren: Z_SIREN.readonly(),
  nda: Z_NDA,
  effectifApprenti: Z_EFFECTIF_APPRENTI,

  denominationUsuelle: z.string().optional(),
  formeJuridique: Z_TEXT(),
  adresse: Z_TEXT(),
  complementAdresse: z.string().optional(),
  codePostal: Z_CODE_POSTAL,
  ville: Z_TEXT(),

  avaitActiviteApprentissage: z.string().optional(),
  horsLesMurs: z.string().optional(),
  dateDebutActivite: z.string().optional(),
  dateDebutExerciceComptable: z.string().optional(),
  dateFinExerciceComptable: z.string().optional(),

  partActiviteApprentissage: z.preprocess(
    (val) => (val === '' ? undefined : val),
    Z_PERCENTAGE(),
  ).optional(),

  hasGroupe: z.string().optional(),
  groupe: z.string().optional(),
  hasReseau: z.string().optional(),
  reseau: z.string().optional(),

  cfa: z.string().optional(),
  sousTraitant: z.string().optional(),
})
  .refine(form => form.dateFinExerciceComptable > form.dateDebutExerciceComptable && form.dateFinExerciceComptable > form.dateDebutActivite, {
    message: t['DETAIL_OFA_INFO_MODIF_MSG8'],
    path: ['dateFinExerciceComptable'],
  })
  .superRefine((form, ctx) => {
    // On force la saisie du groupe si "Oui" a été sélectionné
    if (form.hasGroupe === 'true' && (!form.groupe || form.groupe.trim() === '')) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Ce champ est obligatoire',
        path: ['groupe'],
      });
    }
    // On force la saisie du réseau si "Oui" a été sélectionné
    if (form.hasReseau === 'true' && (!form.reseau || form.reseau.trim() === '')) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Ce champ est obligatoire',
        path: ['reseau'],
      });
    }
  });

export type EditOfaInfoFormResult = z.infer<typeof editOfaInfoFormSchema>